import React from 'react'
import EnquiryTab from './EnquiryTab'

const EnquiryComp = () => {
  return (
    <EnquiryTab />
  )
}

export default EnquiryComp